import { FC } from "react";
import { useTranslation } from "react-i18next";
import i18n from 'i18next';
import { getFirstDisplayText, getKeyByLang, getNameByLang } from "utils/util";
import noImage from "images/404.png";


function CheckoutSummaryRender(props: any) {
    const { cartSkuList } = props;
    const { language } = i18n;

    const getSkuTotalPrice = (sku: any) => {
        return +((Number(sku.sellingPrice * sku.quantity) || 0).toFixed(2));
    }

    const getProductTotalPrice = (product: any) => {
        return product.skuList.reduce((p: number, sku: any) => {
            return p += getSkuTotalPrice(sku);
        }, 0).toFixed(2);
    }

    return (
        <>
            {cartSkuList.map((item: any, index: number) => {
                const productName = getFirstDisplayText(item[getKeyByLang(language, 'productName')], item.productName, item.title, item.name);
                return (
                    <div
                        className="flex items-start justify-between gap-3 text-sm text-neutral-500 dark:text-neutral-400 font-normal"
                        key={index}
                    >
                        <div className="flex min-w-0 gap-3">
                            <img src={item.pictureUrls?.[0] || noImage} className="h-16 w-16 shrink-0 rounded-lg object-cover sm:h-[88px] sm:w-[88px]" alt="" />
                            <div className="flex min-w-0 flex-col">
                                <div className="break-words text-neutral-800 dark:text-neutral-200">{productName}</div>
                                {item.skuList.map((sku: any) => {
                                    return (
                                        <div className="break-words" key={sku.id}>{getFirstDisplayText(sku[getNameByLang(language)], sku.name, sku.nameHk, sku.nameEn, productName)} x {sku.quantity}</div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="shrink-0 pt-0.5 sm:pt-0 sm:self-center">{`$${getProductTotalPrice(item)}`}</div>
                    </div>
                );
            })}
        </>
    );
}

export interface ComponentProps {
    /* 订单总价 */
    transcationTotalAmount: number;
    /* 订单原始总价 */
    originCartTransactionTotal: number;
    /* 实际-运费 */
    shippingFee: number;
    /* 原始-运费 */
    originExpressFee: number;
    /* VIP折扣金额 */
    vipDiscountAmount: number;
    /* 优惠券抵扣金额 */
    couponDiscountAmount: number;
    cartSkuList: any[];
    /* 折扣信息 */
    discountInfo: any;
    // onCartSkuListChange?: () => void;
};

const OrderReview: FC<ComponentProps> = (props) => {
    const { t } = useTranslation();
    const { language } = i18n;
    const { transcationTotalAmount, vipDiscountAmount, couponDiscountAmount, originCartTransactionTotal, shippingFee, originExpressFee, cartSkuList, discountInfo } = props;

    return (
        <div className="listingSection__wrap">
            <div>
                <span className="text-xl font-semibold sm:text-2xl lg:text-3xl">{t('checkout.check_order')}</span>
            </div>
            <CheckoutSummaryRender cartSkuList={cartSkuList} />
            {/* SUM */}
            <div className="flex flex-col space-y-3 text-sm sm:space-y-4 sm:text-base">
                <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                <div className="flex justify-between gap-4 font-semibold">
                    <span className="min-w-0">{t('checkout.subtotal')}:</span>
                    <span className="shrink-0">{`HKD $${originCartTransactionTotal}`}</span>
                </div>
                <div className="flex justify-between gap-4 font-semibold">
                    <span className="min-w-0">{t('checkout.delivery_fee')}:</span>
                    <span className={`shrink-0 ${shippingFee === 0 ? 'line-through' : ''}`}>{`HKD $${originExpressFee}`}</span>
                </div>
                <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                {
                    vipDiscountAmount ? (
                        <div className="flex justify-between gap-4 font-semibold">
                            <span className="min-w-0">{t('coupon.vipDiscountAmount')}:</span>
                            <span className="shrink-0">{`HKD $${vipDiscountAmount || 0}`}</span>
                        </div>
                    ) : null
                }
                {
                    couponDiscountAmount ? (
                        <div className="flex justify-between gap-4 font-semibold">
                            <span className="min-w-0">{t('coupon.couponDiscountAmount')}:</span>
                            <span className="shrink-0">{`HKD $${couponDiscountAmount || 0}`}</span>
                        </div>
                    ) : null
                }
                {
                    discountInfo ? (
                        <div className="flex justify-between gap-4 font-semibold">
                            <span className="min-w-0 break-words">{t('coupon.discountName')}:</span>
                            <span className="shrink-0 text-right">{discountInfo?.[getKeyByLang(language, 'discountName')] || '-'}</span>
                        </div>
                    ) : null
                }
                <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
                <div className="flex justify-between gap-4 font-semibold">
                    <span className="min-w-0">{t('cart.total_amount')}:</span>
                    <span className="shrink-0">{`HKD $${transcationTotalAmount + shippingFee}`}</span>
                </div>
            </div>
        </div>
    );
};

export default OrderReview;
